import { BackupStatuses } from 'mbs-ui-shared@models/backupHistory';

/**
 * @see LastRunInfo
 */
export enum RecoveryStatus {
  Overdue = -2,
  Started = -1,
  Unknown,
  Succeed,
  Warning,
  Failed,
  Running
}

export const MonitoringStatusToRecovery = {
  [BackupStatuses.None]: RecoveryStatus.Unknown,
  [BackupStatuses.Unknown]: RecoveryStatus.Unknown,
  [BackupStatuses.Success]: RecoveryStatus.Succeed,
  [BackupStatuses.Failed]: RecoveryStatus.Failed,
  [BackupStatuses.Interrupted]: RecoveryStatus.Warning,
  [BackupStatuses.UnexpectedlyClosed]: RecoveryStatus.Warning,
  [BackupStatuses.Warning]: RecoveryStatus.Warning,
  [BackupStatuses.Running]: RecoveryStatus.Succeed,
  [BackupStatuses.Overdue]: RecoveryStatus.Failed
};
